module.exports = __webpack_public_path__ + "img/download_icon.9eef0fc4.svg";